export default __webpack_public_path__ + "static/media/213.4c502db2.png";